<div class="c-highscoreInfoModal">
  <div class="c-highscoreInfoModal__container">
    <slotcom-navigation-button
      type="close"
      topPosition="-3"
      rightPosition="-1"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div class="c-highscoreInfoModal__info">
      <span class="c-highscoreInfoModal__title">{{ 'home.lobby.modals.highscore-info.title' | translate }}</span>

      <div class="c-highscoreInfoModal__infoContainer">
        <div class="c-highscoreInfoModal__logo">
          <div class="c-highscoreInfoModal__icon-front-shine"></div>
          <div class="c-highscoreInfoModal__icon"></div>
          <div class="c-highscoreInfoModal__icon-back-shine"></div>
        </div>

        <div class="c-highscoreInfoModal__subtitles">
          <span>{{ 'home.lobby.modals.highscore-info.subtitle' | translate }}</span>
          <span [innerHTML]="'home.lobby.modals.highscore-info.message' | translate"></span>
          @if (showBarText) {
            <span [innerHTML]="'home.lobby.modals.highscore-info.bar-message' | translate"></span>
          }
        </div>
      </div>
    </div>

    <div class="c-highscoreInfoModal__image">
      @if (culture === 'es') {
        <slotcom-tooltip-bubble
          id="tooltip-bubble-1"
          [classes]="['c-tooltipBubble--slim']"
          arrowPosition="bottom"
          arrowPercentPosition="85"
          >{{ 'home.lobby.modals.highscore-info.bubble' | translate }}</slotcom-tooltip-bubble
        >
        <slotcom-tooltip-bubble
          id="tooltip-bubble-2"
          [classes]="['c-tooltipBubble--slim']"
          arrowPosition="top"
          arrowPercentPosition="49"
          >{{ 'home.lobby.modals.highscore-info.bubble-2' | translate }}</slotcom-tooltip-bubble
        >
      }

      @if (culture === 'de') {
        <slotcom-tooltip-bubble
          id="tooltip-bubble-1"
          [classes]="['c-tooltipBubble--slim']"
          arrowPosition="bottom"
          arrowPercentPosition="77.5"
          >{{ 'home.lobby.modals.highscore-info.bubble' | translate }}</slotcom-tooltip-bubble
        >
        <slotcom-tooltip-bubble
          id="tooltip-bubble-2"
          [classes]="['c-tooltipBubble--slim']"
          arrowPosition="top"
          arrowPercentPosition="53.5"
          >{{ 'home.lobby.modals.highscore-info.bubble-2' | translate }}</slotcom-tooltip-bubble
        >
      }

      @if (culture !== 'es' && culture !== 'de') {
        <slotcom-tooltip-bubble
          id="tooltip-bubble-1"
          [classes]="['c-tooltipBubble--slim']"
          arrowPosition="bottom"
          arrowPercentPosition="83.5"
          >{{ 'home.lobby.modals.highscore-info.bubble' | translate }}</slotcom-tooltip-bubble
        >
        <slotcom-tooltip-bubble
          id="tooltip-bubble-2"
          [classes]="['c-tooltipBubble--slim']"
          arrowPosition="top"
          arrowPercentPosition="41.5"
          >{{ 'home.lobby.modals.highscore-info.bubble-2' | translate }}</slotcom-tooltip-bubble
        >
      }
    </div>
  </div>
</div>
